var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-row',{staticClass:"fill-height",attrs:{"align":"start","justify":"center","no-gutters":""}},[_c('onglet')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }